import React from 'react';
import WarrantyChecker from '../components/WarrantyChecker';

const Warranty = () => {
  return <WarrantyChecker />;
};

export default Warranty;
